import PropTypes from "prop-types";
import { Form, InputGroup } from "react-bootstrap";

const TextareaForm = ({
  id,
  register,
  errors,
  type = "text",
  label = "",
  labelLeft = "",
  labelRight = "",
  helperText = "",
  placeholder = "",
  disabled = false,
  textAlign = "left",
  size = "",
  rowSize = "4",
}) => {
  const hasError = errors[id] !== undefined;
  return (
    <Form.Group controlId={id} style={{ marginBottom: "1rem" }}>
      {label && <Form.Label>{label}</Form.Label>}
      <InputGroup size={size}>
        {labelLeft && <InputGroup.Text>{labelLeft}</InputGroup.Text>}
        <textarea
          id={id}
          rows={rowSize}
          className={[
            "form-control",
            size ? `form-control-${size}` : "",
            hasError ? "is-invalid" : "",
          ].join(" ")}
          style={{ textAlign }}
          type={type}
          placeholder={placeholder}
          readOnly={disabled}
          {...register(id)}
        />
        {labelRight && <InputGroup.Text>{labelRight}</InputGroup.Text>}
      </InputGroup>

      {hasError && (
        <div className="invalid-feedback" style={{ display: "block" }}>
          {errors[id].message}
        </div>
      )}
      {helperText && <Form.Text muted>{helperText}</Form.Text>}
    </Form.Group>
  );
};

TextareaForm.propTypes = {
  id: PropTypes.string.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.objectOf(PropTypes.any).isRequired,
  label: PropTypes.string,
  labelLeft: PropTypes.string,
  labelRight: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  textAlign: PropTypes.string,
  rowSize: PropTypes.string,
};

TextareaForm.defaultProps = {
  textAlign: "",
  label: "",
  labelLeft: "",
  labelRight: "",
  helperText: "",
  disabled: false,
  size: "",
  onChange: null,
  placeholder: "",
  rowSize: "4",
  type: "text",
};

export default TextareaForm;
